const CREDIT_TYPES = {
  currency: 'currency',
  coins: 'coins',
};

export { CREDIT_TYPES };
